import axios from "axios";

const API_BASE = process.env.REACT_APP_USER_SERVICE_URL;
const API = axios.create({
  baseURL: API_BASE,
});

export async function fetchBuyers({ page = 0, size = 10, search = "" } = {}) {
  try {
    const res = await API.get("admins/users", {
      params: { page, size, search },
    });

    // Extract _embedded.adminUserResponseList safely
    const buyers = res.data._embedded?.adminUserResponseList || [];

    // Return frontend-friendly format
    return {
      buyers,
      page: res.data.page || { number: 0, totalPages: 0, size: size },
      links: res.data._links || {},
    };
  } catch (error) {
    console.error("Failed to fetch buyers:", error);
    return {
      buyers: [],
      page: { number: 0, totalPages: 0, size: size },
      links: {},
    };
  }
}

export async function updateBuyerStatus(userId, status) {
  return API.patch(`/admins/user/${userId}/status`, { status });
}

export async function updateUserStatus(userId, status) {
  // PUT /api/v3/admin/users/{id}/status
  return { success: true };
}

export async function deleteUser(userId) {
  // DELETE /api/v3/admin/users/{id}
  return { success: true };
}
